import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

/**
 * Medya galeri öğesi: başlık düzenleme ve indirme.
 * Kullanan bileşen `dataItem` prop'u ve `galleryModule` (ör. 'productMediaGallery') sağlamalı.
 */
export default {
  data() {
    return {
      titleDraft: '',
      savingTitle: false,
      downloading: false,
    }
  },
  computed: {
    titleChanged() {
      return (this.titleDraft || '').trim() !== (this.dataItem.title || '')
    },
  },
  methods: {
    resetTitleDraft() {
      this.titleDraft = this.dataItem.title || ''
    },
    saveTitle() {
      if (this.savingTitle || !this.titleChanged) {
        return
      }
      this.savingTitle = true
      this.$store.dispatch(`${this.galleryModule}/updateTitle`, { id: this.dataItem.id, title: this.titleDraft.trim() })
        .then(res => {
          if (res && res.status) {
            this.resetTitleDraft()
            this.showMediaToast('success', 'İşlem Başarılı!', 'Başlık güncellendi.')
          } else {
            this.showMediaToast('danger', 'İşlem Hatası!', (res && res.message) || 'Başlık güncellenemedi.')
          }
        })
        .finally(() => {
          this.savingTitle = false
        })
    },
    downloadMedia() {
      if (this.downloading) {
        return
      }
      this.downloading = true
      this.$store.dispatch('downloads/downloadMedia', this.dataItem.id)
        .then(res => {
          if (!res || !res.status) {
            this.showMediaToast('danger', 'İndirme Hatası!', (res && res.message) || 'Dosya indirilemedi.')
            return
          }
          // Sekme açmadan indir
          const url = window.URL.createObjectURL(res.blob)
          const link = document.createElement('a')
          link.href = url
          link.download = res.fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          // Aynı anda bırakılırsa bazı tarayıcılar (Safari/Firefox) indirmeyi iptal ediyor
          setTimeout(() => window.URL.revokeObjectURL(url), 1000)
        })
        .finally(() => {
          this.downloading = false
        })
    },
    showMediaToast(variant, title, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon: variant === 'success' ? 'CheckIcon' : 'XIcon',
          text,
          variant,
        },
      })
    },
  },
}
